import { IconProps } from "../../utils/global-types/global-types";

const BulbIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g clipPath="url(#clip0_4652_121203)">
      <path
        fill="#FFD15C"
        d="M11.063 13.763a4.2 4.2 0 0 1 1.275-1.95 5.12 5.12 0 0 0 1.837-3.938c0-2.925-2.437-5.325-5.437-5.175-2.663.112-4.838 2.363-4.913 5.025a5.14 5.14 0 0 0 1.838 4.088 4.02 4.02 0 0 1 1.312 1.95z"
      ></path>
      <path
        fill="#fff"
        d="M8.513 13.838h.337L7.35 8.25h.113a.74.74 0 0 0 .525-.225.34.34 0 0 1 .262-.112.34.34 0 0 1 .263.112c.262.3.712.3.975 0a.34.34 0 0 1 .262-.112c.075 0 .188.037.263.112.15.15.3.225.525.225h.112l-1.462 5.588h.337l1.538-5.85c0-.075 0-.15-.075-.188-.075-.037-.15 0-.188.038q-.113.112-.225.112c-.112 0-.187-.037-.3-.112-.15-.15-.3-.225-.487-.225-.188 0-.338.075-.488.225a.36.36 0 0 1-.525 0 .6.6 0 0 0-.487-.225.6.6 0 0 0-.488.225.43.43 0 0 1-.3.112c-.075 0-.187-.037-.225-.112-.037-.038-.112-.075-.187-.038-.075.038-.113.113-.075.188z"
      ></path>
      <path
        fill="#344A5E"
        d="M7.838 17.213c.187.45.637.787 1.162.787s.975-.337 1.163-.788z"
      ></path>
      <path
        fill="#344A5E"
        d="M10.387 17.25H7.65a.67.67 0 0 1-.675-.675v-2.85h4.087v2.85c0 .375-.3.675-.675.675"
      ></path>
      <path
        fill="#415A6B"
        d="M11.025 15.15h-4.05a.416.416 0 0 1-.412-.412c0-.226.187-.413.412-.413h4.05c.225 0 .412.188.412.413a.416.416 0 0 1-.412.412M11.025 16.463h-4.05a.416.416 0 0 1-.412-.413c0-.225.187-.413.412-.413h4.05c.225 0 .412.188.412.413a.416.416 0 0 1-.412.412"
      ></path>
      <path
        fill="#FFD15C"
        d="M9 0a.376.376 0 0 0-.375.375V1.65c0 .188.15.375.375.375s.375-.15.375-.375V.375A.376.376 0 0 0 9 0M3.975 2.288a.36.36 0 0 0-.525 0 .36.36 0 0 0 0 .525l.9.9c.15.15.375.15.525 0a.36.36 0 0 0 0-.525zM2.812 7.463H1.537a.376.376 0 0 0 0 .75h1.275c.188 0 .375-.15.375-.375a.4.4 0 0 0-.375-.375M4.35 11.963l-.9.9a.36.36 0 0 0 0 .524c.15.15.375.15.525 0l.9-.9a.36.36 0 0 0 0-.524.36.36 0 0 0-.525 0M13.65 11.963a.36.36 0 0 0-.525 0 .36.36 0 0 0 0 .525l.9.9c.15.15.375.15.525 0a.36.36 0 0 0 0-.525zM16.463 7.463h-1.276a.376.376 0 0 0 0 .75h1.275a.376.376 0 0 0 0-.75M14.025 2.288l-.9.9a.36.36 0 0 0 0 .524c.15.15.375.15.525 0l.9-.9a.36.36 0 0 0 0-.524.363.363 0 0 0-.525 0"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4652_121203">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default BulbIcon;
